import {Box, Button, Heading, Stack, VStack} from '@chakra-ui/react'
import Link from 'next/link'

import Header from 'components/header'
import ALink from 'components/link'
import MDXWrapper from 'components/mdx'
import {space} from 'config/theme'
import {FiArrowRight} from 'react-icons/fi'

import Layout from './main'

type LearnLayoutProps = {
  children: JSX.Element | JSX.Element[]
  title: string
}

const links = {
  Detail: '#detail',
  Depth: '#depth',
  Speed: '#speed',
  Nuance: '#nuance',
  Engagement: '#engagement',
  Collaboration: '#collaboration',
  Openness: '#openness',
  Experience: '#experience'
}

function NavLinks() {
  return (
    <Stack spacing={space.sm} pr={space.md}>
      <Heading color='gray.500' size='xs' textTransform='uppercase'>
        Sections
      </Heading>
      {Object.entries(links).map((entry, key) => (
        <Box key={key} fontSize='sm' fontWeight='semibold'>
          <ALink href={entry[1]}>{entry[0]}</ALink>
        </Box>
      ))}
    </Stack>
  )
}

export default function LearnLayout({children, title}: LearnLayoutProps) {
  return (
    <MDXWrapper>
      <Layout title={title}>
        <Header>{title}</Header>
        <VStack px={space.md} py={space.lg} spacing={space.md}>
          <Stack isInline justify='center' width='100%'>
            <Box display={{base: 'none', md: 'inherit'}} mr={space.lg}>
              <NavLinks />
            </Box>
            <Box maxW={{base: '100%', md: '60ch'}}>{children}</Box>
          </Stack>

          <Heading
            fontWeight='normal'
            size='lg'
            maxWidth='50ch'
            textAlign='center'
          >
            Discover what Conveyal can do for your organization
          </Heading>
          <Link href='/contact/new'>
            <Button colorScheme='blue' size='lg' rightIcon={<FiArrowRight />}>
              Get started
            </Button>
          </Link>
        </VStack>
      </Layout>
    </MDXWrapper>
  )
}
